import React, { useContext, useEffect, useState } from 'react'
import logo from '../../assets/images/logo.png'

import ProgressBar from '../../components/ProgressBar'
import Context from '../../context'
import { doLogin, isAuthenticated } from '../../services/auth'
import history from '../../services/history'

export default function Login() {
  const { setUser } = useContext(Context)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [errorMsg, setErrorMsg] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (isAuthenticated()) {
      history.replace('/dashboard')
    }
  }, [])

  const handleSubmit = () => {
    setErrorMsg('')
    setIsLoading(true)
    const goLogin = async () => {
      return doLogin(email, password)
    }

    goLogin().then(r => {
      if (r.error) {
        setErrorMsg(r.error.message)
        setIsLoading(false)
      } else {
        setUser({ ...r })
        history.replace('/dashboard')
      }
    })
  }

  return (
    <div className="login-container h-100">
      <div className="container h-100 w-100">
        <div className="row h-100 align-items-center text-center login-background">
          <div className="col-6 mx-auto align-middle">
            <img src={logo} className="mb-4" alt="Clube Gazeta" height="72" />
            <form
              className="form-signin"
              onSubmit={e => {
                e.preventDefault()
                handleSubmit()
              }}
            >
              <label className="w-100 login-text text-left" htmlFor="inputEmail">
                E-mail
              </label>
              <input
                value={email}
                onChange={e => setEmail(e.target.value)}
                type="email"
                name="email"
                id="inputEmail"
                className="form-control"
                autoComplete="email"
              />
              <label className="w-100 login-text text-left" htmlFor="inputPassword">
                Senha
              </label>
              <input
                value={password}
                onChange={e => setPassword(e.target.value)}
                className="form-control"
                type="password"
                id="inputPassword"
                name="password"
                autoComplete="current-password"
              />
              {errorMsg !== '' && (
                <div style={{ marginTop: '20px' }} className="alert alert-danger" role="alert">
                  {errorMsg}
                </div>
              )}
              {isLoading && <ProgressBar height="20px" marginTop="20px" />}
              <button
                style={{ marginTop: '20px' }}
                className="button-signin btn btn-info"
                type="submit"
              >
                Entrar
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}
